import { render, staticRenderFns } from "./AcceptanceCommentDialog.vue?vue&type=template&id=38d918e5&"
import script from "./AcceptanceCommentDialog.vue?vue&type=script&lang=js&"
export * from "./AcceptanceCommentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports